import { render } from "./personalinformation.vue?vue&type=template&id=0866fe34"
import script from "./personalinformation.vue?vue&type=script&lang=js"
export * from "./personalinformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__